import UICheckbox from './UICheckbox'
export default UICheckbox
